<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <div style="min-height: 1000px;min-width: 1200px;">

      <!-- <iframe src="https://new-retail-console.jclingshou.com/"
              frameborder="0"
              width="100%"
              height="1000px"></iframe> -->
      <object data="https://new-retail-console.jclingshou.com"
              type="text/html"
              width="100%"
              height="1000px"></object>
    </div>
    <!-- <Info></Info>
    <div class="currency_boxs my_box">
      <div style="width:220px;">
        <el-menu :default-active="activeIndex"
                 menu-trigger="click"
                 class="el-menu-demo"
                 mode="vertical"
                 @select="handleSelect">
          <el-menu-item index="0">我的订单</el-menu-item>
          <el-menu-item index="1">我的会员卡</el-menu-item>
          <el-menu-item index="2">意见反馈</el-menu-item>
          <el-menu-item index="3">重要说明</el-menu-item>
        </el-menu>
      </div>
      <div class="content">
        <Order v-if="activeIndex == 0"></Order>
        <div v-if="activeIndex == 1">暂无会员卡</div>
        <Opinion v-if="activeIndex== 2"></Opinion>
      </div>
    </div> -->

  </div>
</template>

<script>
import Order from './components/order.vue'
import Opinion from './components/opinion.vue'
import Info from './components/info.vue'
export default {
  components: { Order, Info, Opinion },
  data () {
    return {
      isWechatPay: false,
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
      activeIndex: 2
    }
  },
  created () {

  },
  methods: {
    handleSelect (index) {
      console.log(index)
      this.activeIndex = index;
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  // min-height: 100vh;
  background-color: #f5f5f5;
  .my_info {
    padding: 32px 0;
    box-sizing: border-box;
    .my_img {
      width: 86px;
      height: 86px;
      margin-right: 20px;
      border-radius: 50%;
    }
    .my_content {
      flex: 1;
      text-align: left;
      color: #fff;
    }
  }
  .my_box {
    padding: 30px 0 60px 0;
    box-sizing: border-box;
    display: flex;
    .content {
      flex: 1;
      margin-left: 20px;
      background-color: #fff;
      padding: 20px 30px;
      box-sizing: border-box;
    }
  }
}
</style>
